import { Props } from "@greeter/matter";
import { classNames } from "@greeter/util";
import css from "./ErrorBorder.module.scss";

export type ErrorBorderProps = Props & { error?: boolean };

export function ErrorBorder({className, error, ...props}: ErrorBorderProps) {
  return <div {...classNames(className, error && css.ErrorBorder)} {...props} />
}
